import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Globals } from '../../_models/globals';
import { DataTableDirective } from 'angular-datatables';
import { AlertService } from '../../_services/alert.service';
import { Subject } from 'rxjs';
import { saveAs } from 'file-saver';
import { ExcelServiceService } from '../../_models/excel-service.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { User } from '../../_models/user';

@Component({
  selector: 'app-tickets-list',
  templateUrl: './tickets-list.component.html',
  styleUrls: ['./tickets-list.component.scss'],
})
export class TicketsListComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  totalRecords: number;
  ticketList: any;

  constructor(public user: User, private http: HttpClient, private alertService: AlertService, private excelService: ExcelServiceService, private api: ApiIntegration, private g: Globals) {
    //this.getAllAdminUsers();

  }

  changeStatus(notImpl) {
  }

  ngOnInit(): void {
    this.getAllAdminUsers();
  }


  getAllAdminUsers() {
    this.dtOptions = {
      pagingType: 'full_numbers',
      lengthMenu: [20, 50, 100, 200],
      pageLength: 20,
      language: {
        searchPlaceholder: 'Search by Ticket # / Status'
      },
      serverSide: true,

      ajax: (dataTablesParameters: any, callback) => {
        dataTablesParameters.start = 0;
        let query: any = {
          userId: this.user.userId,
          page: dataTablesParameters.start ? (dataTablesParameters.start / dataTablesParameters.length) : dataTablesParameters.start,
          size: dataTablesParameters.length
        }
        if ((dataTablesParameters.search || {}).value && (dataTablesParameters.search || {}).value.trim() !== '') {
          query.searchString = dataTablesParameters.search.value.trim();
        }
        var header1 = new HttpHeaders();
        header1 = header1.append('Content-Type', 'application/json');
        header1 = header1.append('Accept', 'application/json');
        header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
        let apiMethod = 'api/getSupportTicketsList';

        this.g.loaderDisplay = "display";
        this.http.get(environment.apiUrl + apiMethod, { params: query, headers: header1 })
          .subscribe((resp: any) => {
            this.g.loaderDisplay = "";

            this.ticketList = resp.supportTicketResponses;
            this.totalRecords = resp.noOfTickets;
            // this.alertService.success('Success',resp['message']);

            callback({
              recordsTotal: resp.noOfTickets,
              recordsFiltered: resp.noOfTickets
            });
          },
            (err) => {
              this.g.loaderDisplay = "";
              this.alertService.error('Error', err);
            });
      }
    };

  }


  ngAfterViewInit(): void {
    this.dtTrigger.next(true);
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {

      dtInstance.destroy();

      this.dtTrigger.next(true);
    });
  }

}
